import request from '../utils/request'


//卡密查询
export function queryCard(params) {
    return request({
        url: '/mxbc/queryCard',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//搜索地点经纬度
export function searchLocation(params) {
    return request({
        url: '/mxbc/searchLocation',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//经纬度查询店铺
export function findNear(data) {
    return request({
        url: '/mxbc/findNear',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//获取可下单商品列表
export function getCan(params) {
    return request({
        url: '/mxbc/getCan',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//商品列表
export function menu(data) {
    return request({
        url: '/mxbc/menu',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//下单
export function update(data){
    return request({
        url: '/mxbc/update',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//下单
export function updateADC(data){
    return request({
        url: '/mxbc/updateADC',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//下单
export function updateTOP(data){
    return request({
        url: '/mxbc/updateTOP',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}
//查询订单
export function queryOrder(params){
    return request({
        url: '/mxbc/queryOrder',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//更新token
export function updateTK(data){
    return request({
        url: '/mxbc/updateTK',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}